/**
 * EncounterLoadMore
 *
 * Infinite scroll trigger for mobile view.
 * Uses IntersectionObserver to automatically load more items.
 */

import React from 'react';
import { useEncounterList } from '../EncounterListContext';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';

export function EncounterLoadMore() {
  const { hasMore, loading, loadingMore, loadMore, config, pagination } = useEncounterList();

  const { triggerRef } = useInfiniteScroll({
    enabled: config.enableInfiniteScroll !== false,
    onLoadMore: loadMore,
    hasMore,
    loading: loadingMore,
  });

  // Don't show if no more items or pagination is disabled
  if (!hasMore && !loadingMore) {
    // Show end of list indicator if there are items
    if (pagination.total > 0) {
      return (
        <div className="py-4 text-center text-sm text-gray-500">
          End of list
        </div>
      );
    }
    return null;
  }

  return (
    <div ref={triggerRef} className="py-6 text-center">
      {loadingMore ? (
        <div className="flex items-center justify-center gap-2">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600" />
          <span className="text-sm text-gray-500">Loading more...</span>
        </div>
      ) : (
        <button
          type="button"
          onClick={loadMore}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-50"
        >
          Load More
        </button>
      )}
    </div>
  );
}

export default EncounterLoadMore;
